import { createDotGlobePattern } from "./internal/dotGlobeCore";

export const key = "dot-globe-corner-left";

// Oversized globe pinned to the bottom-left corner.
// Mirror of `dot_globe_corner` (which sits in the bottom-right). Same size,
// same slow rotation — only the placement differs.
const VISIBLE_FRACTION = 0.55;
const SIZE_RATIO = 0.85;
const MIN_RADIUS = 180;
const MAX_RADIUS = 720;
const ROTATION_SPEED = 0.0017;

export default createDotGlobePattern({
  placement: ({ width, height }) => {
    const radius = Math.max(
      MIN_RADIUS,
      Math.min(MAX_RADIUS, Math.min(width, height) * SIZE_RATIO),
    );
    const inset = radius * VISIBLE_FRACTION;
    return {
      cx: inset * 0.4,
      cy: height - inset * 0.4,
      radius,
    };
  },
  rotationSpeed: ROTATION_SPEED,
  // Mirror the background diagonal so color-2 sits under the visible arc of
  // the globe (bottom-left), keeping the same composition as the right
  // variant.
  gradientDirection: { x0: 1, y0: 0, x1: 0, y1: 1 },
});
